<template>
  <div class="onboarding-instant-quote-bush-trimming-generated-quote--container">
    <InstantQuotePriceAndSchedule :current-quote="currentInstantQuote" />
    <div v-if="currentInstantQuote.instant_quote_status === 'customer.pending'">
      <div
        class="onboarding-instant-quote-bush-trimming-generated-quote--pending-buttons"
        test-id="pending-buttons"
      >
        <LsButton
          text="approve work"
          track-id="onboarding_instant_quote_bush_trimming_generated_quote-approve_work"
          test-id="approve_work"
          :loading="isUpdatingLocal"
          @click="acceptQuote"
        />
        <LsButton
          class="onboarding-instant-quote-bush-trimming-generated-quote--turn-down"
          bg-color="primary-light"
          text-color="primary"
          text="turn down"
          track-id="onboarding_instant_quote_bush_trimming_generated_quote-turn_down"
          test-id="turn_down"
          @click="declineQuote"
        />
      </div>
    </div>
    <InstantQuoteAuthorized
      v-else
      test-id="authorized"
      :date-authorized="currentInstantQuote.customer_accepted_at"
      :date-rejected="currentInstantQuote.customer_rejected_at"
      :onboarding="true"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import VueTypes from 'vue-types';
import { ONBOARDING__ACCEPT_INSTANT_QUOTE } from '@/store/types';
import { LsButton } from '@/components/common';
import { lsModalService, lsPropTypeHelpers } from 'ls-vue-common';
import { InstantQuoteTurnDownModal } from '@/modals/';
import InstantQuotePriceAndSchedule from '@/views/Authorized/OrderServicesView/OrderServicesFormView/components/InstantQuotePriceAndSchedule.vue';
import InstantQuoteAuthorized from '@/views/Authorized/OrderServicesView/OrderServicesFormView/components/InstantQuoteAuthorized.vue';

export default {
  name: 'OnboardingInstantQuoteGeneratedQuote',
  components: { LsButton, InstantQuotePriceAndSchedule, InstantQuoteAuthorized },
  props: {
    //eslint-disable-next-line vue/prop-name-casing
    currentInstantQuote: VueTypes.shape({
      id: VueTypes.number,
      instant_quote_bush_trimming: VueTypes.shape({
        bushes_0ft_5ft_count: VueTypes.custom(lsPropTypeHelpers.numberOrNull),
        bushes_5ft_10ft_count: VueTypes.custom(lsPropTypeHelpers.numberOrNull),
        bushes_over_10ft_count: VueTypes.custom(lsPropTypeHelpers.numberOrNull),
        bushes_property_location_back: VueTypes.custom(lsPropTypeHelpers.booleanOrNull),
        bushes_property_location_front: VueTypes.custom(lsPropTypeHelpers.booleanOrNull),
        bushes_property_location_full: VueTypes.custom(lsPropTypeHelpers.booleanOrNull),
        bushes_property_location_left: VueTypes.custom(lsPropTypeHelpers.booleanOrNull),
        bushes_property_location_right: VueTypes.custom(lsPropTypeHelpers.booleanOrNull),
        desired_trim_length: VueTypes.custom(lsPropTypeHelpers.stringOrNull),
        details: VueTypes.custom(lsPropTypeHelpers.stringOrNull),
        desired_clippings_haulaway: VueTypes.custom(lsPropTypeHelpers.booleanOrNull),
        images: VueTypes.array,
      }).loose,
    }).loose.isRequired,
  },
  data() {
    return {
      isUpdatingLocal: false,
    };
  },
  methods: {
    ...mapActions([ONBOARDING__ACCEPT_INSTANT_QUOTE]),
    async acceptQuote() {
      this.isUpdatingLocal = true;
      await this[ONBOARDING__ACCEPT_INSTANT_QUOTE]({
        instantQuoteId: this.currentInstantQuote.id,
      });
      this.isUpdatingLocal = false;
    },
    declineQuote() {
      lsModalService.open({
        parent: this,
        component: InstantQuoteTurnDownModal,
        props: {
          currentInstantQuoteId: this.currentInstantQuote.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.onboarding-instant-quote-bush-trimming-generated-quote--container {
  padding-top: 20px;
}

.onboarding-instant-quote-bush-trimming-generated-quote--pending-buttons {
  padding-top: 20px;
}

.onboarding-instant-quote-bush-trimming-generated-quote--turn-down {
  margin-left: 10px;
  @media (max-width: $mobile-max-width) {
    margin-left: 0;
    margin-top: 10px;
  }
}
</style>
